@charset "UTF-8";

/* src/app/modules/institutions/institutions-details/institutions-details.component.scss */
:host {
  max-height: calc(100dvh - 60px);
  -webkit-overflow-scrolling: touch;
}
.cw-institutiondetails {
  max-height: calc(100dvh - 108px);
  overflow-y: auto;
}
:host h2.cw-icon-container {
  padding-left: calc(3rem + 5px);
  position: relative;
}
:host h2 > .cw-grid-icon {
  font-size: 3rem;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
:host .cw-header-characteristic {
  align-self: center;
  color: var(--color-default-dark);
  font-size: 1.4rem;
  font-weight: 500;
  margin-left: 1rem;
  text-transform: uppercase;
  white-space: nowrap;
}
/*# sourceMappingURL=institutions-details.component.css.map */
